import Vue from 'vue'
import Vuex from 'vuex'
import ky from 'ky'

import { USB_API_URL } from '../config'

Vue.use(Vuex)

const usbClient = ky.extend({
  prefixUrl: USB_API_URL
})

export default new Vuex.Store({
  state: {
    rooms: null,
    sensorData: {}
  },
  mutations: {
    setRooms(state, rooms) {
      state.rooms = rooms
    },
    setEntityData(state, { entityId, data }) {
      Vue.set(state.sensorData, entityId, data)
    }
  },
  getters: {
    entityData: state => entityId => state.sensorData[entityId]
  },
  actions: {
    async fetchEntityData({ commit }, entityId) {
      try {
        const res = await usbClient.get(`sensors/entity/${entityId}`).json()
        const data = {}

        for (const feedItem of res.feed) {
          const values = feedItem.timeseries[0]
          if (!values || !values.latest) continue

          data[feedItem.metric] = {
            time: values.latest.time,
            value: values.latest.value
          }
        }

        commit('setEntityData', { entityId, data })
      } catch (error) {
        console.log(error)

        commit('setEntityData', { entityId, data: null })
      }
    }
  }
})
